<template>
    <div><slot>{{text}}</slot></div>
</template>

<skeleton>
    <div class="skeleton">&nbsp;</div>
</skeleton>

<script>
export default {
    name: 'SkText',
    props: {
        text: {},
    },
};
</script>